import { graphql } from 'app/generated/gql'
import type { Client } from '@urql/core'

import type { Transaction as TransactionType, TransactionListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const TRANSACTION_FIELDS = `amount createdDate id locationId orgId patientId procedureCode procedureDescription providerId sikkaOfficeId transactionDate transactionEntryDate transactionSrNo transactionType treatmentCategory type updatedDate vendor version workspaceId`

const LIST_QUERY = graphql(`
  query Transactions($search: String, $pagination: PaginationInput, $sort: SortInput) {
    transactions(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        amount
        createdDate
        id
        locationId
        orgId
        patientId
        procedureCode
        procedureDescription
        providerId
        sikkaOfficeId
        transactionDate
        transactionEntryDate
        transactionSrNo
        transactionType
        treatmentCategory
        type
        updatedDate
        vendor
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query Transaction($id: ID!) {
    transaction(id: $id) {
      amount
      createdDate
      id
      locationId
      orgId
      patientId
      procedureCode
      procedureDescription
      providerId
      sikkaOfficeId
      transactionDate
      transactionEntryDate
      transactionSrNo
      transactionType
      treatmentCategory
      type
      updatedDate
      vendor
      version
      workspaceId
    }
  }
`)

export class TransactionStore extends EntityStore<TransactionType, TransactionListResult> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      extractList: (data: any) => data.transactions,
      extractOne: (data: any) => data.transaction,
    })
  }
}
